(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[756,2576,5124,949],{

/***/ 25222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customerai_personalization_engine; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 4 modules
var DemoForm = __webpack_require__(92472);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(76079);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(2870);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(32511);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/Hero/Hero.tsx










var copy = {
  overline: "CustomerAI Personalization Engine",
  heading: "Personalize every LLM-powered conversation with your customer data",
  description: "Infuse greater customer understanding and personalization into every customer interaction with a seamless API connection between your Segment customer data and ChatGPT or other large language models (LLMs)."
};

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            variant: "h5",
            tag: "p",
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h1",
            tag: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pExtraLarge",
            tag: "p",
            children: copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
              isProgressive: true,
              customFormIdentifier: "customerai-personalization-beta-request",
              customTrackingType: "customerai-personalization-beta-request",
              successMessageAppearance: "twilioLight",
              buttonText: "Join the Beta",
              isLeadEnrichmentFormEnabled: false,
              onSubmit: function onSubmit(data) {
                (0,scripts/* trackProgramSignupForm */.XT)(data);
              },
              successMessage: {
                heading: "You\u2019re all set!",
                description: "Thank you for submitting your request to join the beta! A member of the Segment team will be in touch.",
                buttonText: null
              }
            })
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            width: "645",
            height: "506",
            src: (Hero_2x_default()),
            alt: "",
            loading: "lazy"
          })]
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e15uau8s0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/BuildPersonalizedChatbots/BuildPersonalizedChatbots.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var BuildPersonalizedChatbots_copy = {
  heading: "Quickly build precisely personalized, AI-powered chatbots using any LLM of your choice",
  description: "With the CustomerAI Personalization Engine, businesses no longer have to struggle with the technical difficulties of securely ingesting customer data into LLMs to build personalized chatbots for online recommendations, self-service marketing and pre-sales, support, or agent assistance. The LLM-agnostic Personalization Engine provides an API that taps into Segment\u2019s customer data platform (CDP) to discern and extract only the most relevant information for every interaction while keeping the customer data itself safe and secure."
};

var BuildPersonalizedChatbots = function BuildPersonalizedChatbots() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: BuildPersonalizedChatbots_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: BuildPersonalizedChatbots_copy.description
        })]
      })
    })
  });
};

/* harmony default export */ var BuildPersonalizedChatbots_BuildPersonalizedChatbots = (BuildPersonalizedChatbots);

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e8fh950"
} : 0)( true ? {
  name: "z9xs2w",
  styles: "max-width:844px;margin:0 auto"
} : 0);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/DeepenYourUnderstanding/assets/DeepenYourUnderstanding@2x.png
var DeepenYourUnderstanding_2x = __webpack_require__(89083);
var DeepenYourUnderstanding_2x_default = /*#__PURE__*/__webpack_require__.n(DeepenYourUnderstanding_2x);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/DeepenYourUnderstanding/assets/DeepenYourUnderstanding.webp
var assets_DeepenYourUnderstanding = __webpack_require__(52747);
var DeepenYourUnderstanding_default = /*#__PURE__*/__webpack_require__.n(assets_DeepenYourUnderstanding);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/DeepenYourUnderstanding/assets/DeepenYourUnderstanding@2x.webp
var assets_DeepenYourUnderstanding_2x = __webpack_require__(70749);
var assets_DeepenYourUnderstanding_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DeepenYourUnderstanding_2x);
;// CONCATENATED MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/DeepenYourUnderstanding/DeepenYourUnderstanding.tsx









var DeepenYourUnderstanding_copy = {
  heading: "Deepen your understanding of each customer with contextualized customer data",
  description: "Segment CDP provides the trusted, AI-ready data foundation needed to power intelligent customer engagement and inform every LLM interaction with relevant information about each individual customer."
};

var DeepenYourUnderstanding = function DeepenYourUnderstanding() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: DeepenYourUnderstanding_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: DeepenYourUnderstanding_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
          type: "image/webp",
          srcSet: "".concat((DeepenYourUnderstanding_default()), ", ").concat((assets_DeepenYourUnderstanding_2x_default()), " 2x")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
          src: (DeepenYourUnderstanding_2x_default()),
          alt: "Illustration: Deepen Your Understanding",
          width: "600",
          height: "450",
          loading: "lazy"
        })]
      })
    })]
  });
};

var SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e127k3ot0"
} : 0)("display:flex;align-items:center;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var DeepenYourUnderstanding_DeepenYourUnderstanding = (DeepenYourUnderstanding);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/PersonalizedCustomerEngagement/assets/PersonalizedCustomerEngagement@2x.png
var PersonalizedCustomerEngagement_2x = __webpack_require__(70404);
var PersonalizedCustomerEngagement_2x_default = /*#__PURE__*/__webpack_require__.n(PersonalizedCustomerEngagement_2x);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/PersonalizedCustomerEngagement/assets/PersonalizedCustomerEngagement.webp
var assets_PersonalizedCustomerEngagement = __webpack_require__(86815);
var PersonalizedCustomerEngagement_default = /*#__PURE__*/__webpack_require__.n(assets_PersonalizedCustomerEngagement);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/PersonalizedCustomerEngagement/assets/PersonalizedCustomerEngagement@2x.webp
var assets_PersonalizedCustomerEngagement_2x = __webpack_require__(17338);
var assets_PersonalizedCustomerEngagement_2x_default = /*#__PURE__*/__webpack_require__.n(assets_PersonalizedCustomerEngagement_2x);
;// CONCATENATED MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/PersonalizedCustomerEngagement/PersonalizedCustomerEngagement.tsx









var PersonalizedCustomerEngagement_copy = {
  heading: "Build personalized customer engagement without sacrificing data privacy",
  description: "By utilizing Retrieval Augmented Generation (RAG), the CustomerAI Personalization Engine listens to the customer query and\u2014 based on the natural language message\u2014only extracts the most relevant customer data from Segment to ingest into the LLM for conversational intelligence."
};

var PersonalizedCustomerEngagement = function PersonalizedCustomerEngagement() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizedCustomerEngagement_SectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          children: PersonalizedCustomerEngagement_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: PersonalizedCustomerEngagement_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
          type: "image/webp",
          srcSet: "".concat((PersonalizedCustomerEngagement_default()), ", ").concat((assets_PersonalizedCustomerEngagement_2x_default()), " 2x")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
          src: (PersonalizedCustomerEngagement_2x_default()),
          alt: "Illustration: Build personalized customer engagement",
          width: "580",
          height: "450",
          loading: "lazy"
        })]
      })
    })]
  });
};

var PersonalizedCustomerEngagement_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e11hdf4c0"
} : 0)("display:flex;align-items:center;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var PersonalizedCustomerEngagement_PersonalizedCustomerEngagement = (PersonalizedCustomerEngagement);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/ActivateEngagement/assets/ActivateEngagement@2x.png
var ActivateEngagement_2x = __webpack_require__(31367);
var ActivateEngagement_2x_default = /*#__PURE__*/__webpack_require__.n(ActivateEngagement_2x);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/ActivateEngagement/assets/ActivateEngagement.webp
var assets_ActivateEngagement = __webpack_require__(45731);
var ActivateEngagement_default = /*#__PURE__*/__webpack_require__.n(assets_ActivateEngagement);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/ActivateEngagement/assets/ActivateEngagement@2x.webp
var assets_ActivateEngagement_2x = __webpack_require__(67896);
var assets_ActivateEngagement_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ActivateEngagement_2x);
;// CONCATENATED MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/ActivateEngagement/ActivateEngagement.tsx









var ActivateEngagement_copy = {
  heading: "Activate engagement that gets better with every customer interaction",
  description: "Every interaction with each individual customer fuels a deeper, more intimate understanding for who they are and how they engage. This engagement flywheel generates better customer experiences, increased loyalty, and consistently better business outcomes."
};

var ActivateEngagement = function ActivateEngagement() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActivateEngagement_SectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: ActivateEngagement_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: ActivateEngagement_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
          type: "image/webp",
          srcSet: "".concat((ActivateEngagement_default()), ", ").concat((assets_ActivateEngagement_2x_default()), " 2x")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
          src: (ActivateEngagement_2x_default()),
          alt: "Illustration: Activate engagement that gets better with every customer interaction",
          width: "500",
          height: "450",
          loading: "lazy"
        })]
      })
    })]
  });
};

var ActivateEngagement_SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "evusxfq0"
} : 0)("display:flex;align-items:center;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var ActivateEngagement_ActivateEngagement = (ActivateEngagement);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/recipes/PropCard/index.ts + 6 modules
var PropCard = __webpack_require__(62456);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/AIAnnouncements/assets/AIAnnouncements.webp
var assets_AIAnnouncements = __webpack_require__(6341);
var AIAnnouncements_default = /*#__PURE__*/__webpack_require__.n(assets_AIAnnouncements);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/AIAnnouncements/assets/AIAnnouncements@2x.webp
var AIAnnouncements_2x = __webpack_require__(1412);
var AIAnnouncements_2x_default = /*#__PURE__*/__webpack_require__.n(AIAnnouncements_2x);
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/AIAnnouncements/assets/AIAnnouncements@2x.png
var assets_AIAnnouncements_2x = __webpack_require__(26266);
var assets_AIAnnouncements_2x_default = /*#__PURE__*/__webpack_require__.n(assets_AIAnnouncements_2x);
;// CONCATENATED MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/components/AIAnnouncements/AIAnnouncements.tsx


function AIAnnouncements_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var AIAnnouncements_copy = {
  badge: "Watch now",
  heading: "Discover all the CustomerAI announcements from SIGNAL 2023",
  description: "Hear from Twilio\u2019s CEO on our latest CustomerAI product releases,  including more on the CustomerAI Personalization Engine and how he sees it changing customer engagement.",
  button: {
    text: "Watch on demand",
    url: "https://signal.twilio.com/2023/sign-in?rId=vs-1671250"
  }
};

var AIAnnouncements = function AIAnnouncements() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AIAnnouncements_StyledSectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPropCardBase, {
        reverse: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Img */.Ei, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
              type: "image/webp",
              srcSet: "".concat((AIAnnouncements_default()), ", ").concat((AIAnnouncements_2x_default()), " 2x")
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
              src: (assets_AIAnnouncements_2x_default()),
              alt: "Illustration: Discover all the CustomerAI announcements from SIGNAL 2023",
              width: "331",
              height: "301",
              loading: "lazy"
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PropCard/* Copy */.CK, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
            variant: "outlined",
            children: AIAnnouncements_copy.badge
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Title */.Dx, {
            variant: "h3",
            tag: "h2",
            children: AIAnnouncements_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Text */.xv, {
            variant: "pMedium",
            children: AIAnnouncements_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            href: AIAnnouncements_copy.button.url,
            size: "large",
            tag: "a",
            variant: "filled",
            onClick: function onClick() {
              return (0,scripts/* trackButtonClick */.kO)({
                buttonText: AIAnnouncements_copy.button.text,
                targetUrl: AIAnnouncements_copy.button.url
              });
            },
            children: AIAnnouncements_copy.button.text
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var AIAnnouncements_AIAnnouncements = (AIAnnouncements);

var AIAnnouncements_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1ep6ftv1"
} : 0)( true ? {
  name: "1uplqc8",
  styles: "max-width:1040px;margin:0 auto"
} : 0);

var StyledPropCardBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(PropCard/* default */.ZP,  true ? {
  target: "e1ep6ftv0"
} : 0)("box-shadow:", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[2];
}, ";&:hover{box-shadow:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows[3];
}, ";}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/assets/OgImage.png
var OgImage = __webpack_require__(8847);
var OgImage_default = /*#__PURE__*/__webpack_require__.n(OgImage);
;// CONCATENATED MODULE: ./src/views/AI/CustomerAIPersonalizationEngine/CustomerAIPersonalizationEngine.tsx
















var CustomerAIPersonalizationEngine = function CustomerAIPersonalizationEngine() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "CustomerAI Personalization Engine | Twilio Segment",
      pageOG: (OgImage_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BuildPersonalizedChatbots_BuildPersonalizedChatbots, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeepenYourUnderstanding_DeepenYourUnderstanding, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizedCustomerEngagement_PersonalizedCustomerEngagement, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActivateEngagement_ActivateEngagement, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AIAnnouncements_AIAnnouncements, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var CustomerAIPersonalizationEngine_CustomerAIPersonalizationEngine = (CustomerAIPersonalizationEngine);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1ulwuak0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ./src/pages/solutions/ai/customerai-personalization-engine.tsx



var customerai_personalization_engine_CustomerAIPersonalizationEngine = function CustomerAIPersonalizationEngine() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerAIPersonalizationEngine_CustomerAIPersonalizationEngine, {});
};

/* harmony default export */ var customerai_personalization_engine = (customerai_personalization_engine_CustomerAIPersonalizationEngine);

/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 36594:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ai/customerai-personalization-engine",
      function () {
        return __webpack_require__(25222);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8847:
/***/ (function(module) {

module.exports = "/_next/static/images/OgImage-16e5b67c5553c3b0341cc9c8d539a72e.png";

/***/ }),

/***/ 26266:
/***/ (function(module) {

module.exports = "/_next/static/images/AIAnnouncements@2x-1f08e27856b360277b885f43b9d35193.png";

/***/ }),

/***/ 31367:
/***/ (function(module) {

module.exports = "/_next/static/images/ActivateEngagement@2x-d63cc8cb33569aa0911369795e3f76d8.png";

/***/ }),

/***/ 89083:
/***/ (function(module) {

module.exports = "/_next/static/images/DeepenYourUnderstanding@2x-2c9666f0151133cb3aefd452fb77898e.png";

/***/ }),

/***/ 76079:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-427c4aab566434ddfc883b17ebd8d371.png";

/***/ }),

/***/ 70404:
/***/ (function(module) {

module.exports = "/_next/static/images/PersonalizedCustomerEngagement@2x-5870c6fc4a5f92dfb86638f5daac14eb.png";

/***/ }),

/***/ 6341:
/***/ (function(module) {

module.exports = "/_next/static/images/AIAnnouncements-d5e5bf4f288ac9174fb4f4141f872db8.webp";

/***/ }),

/***/ 1412:
/***/ (function(module) {

module.exports = "/_next/static/images/AIAnnouncements@2x-ac87dac0fd7cd7a8570c9c469c5ff3d5.webp";

/***/ }),

/***/ 45731:
/***/ (function(module) {

module.exports = "/_next/static/images/ActivateEngagement-16ef09da36c631959c46b23d39923396.webp";

/***/ }),

/***/ 67896:
/***/ (function(module) {

module.exports = "/_next/static/images/ActivateEngagement@2x-20e8ef01eaf6c6e05c531891c49de254.webp";

/***/ }),

/***/ 52747:
/***/ (function(module) {

module.exports = "/_next/static/images/DeepenYourUnderstanding-49983c39facf498fab6a58253909e8b6.webp";

/***/ }),

/***/ 70749:
/***/ (function(module) {

module.exports = "/_next/static/images/DeepenYourUnderstanding@2x-342eb04600ef26275a15f9e071b7efa7.webp";

/***/ }),

/***/ 2870:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-c379004d2f5b6b749da25d2509592f59.webp";

/***/ }),

/***/ 32511:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-61a4030969e879a887fe272d27701d70.webp";

/***/ }),

/***/ 86815:
/***/ (function(module) {

module.exports = "/_next/static/images/PersonalizedCustomerEngagement-9ef7d20ade335dfbcebfd4b07ca591f0.webp";

/***/ }),

/***/ 17338:
/***/ (function(module) {

module.exports = "/_next/static/images/PersonalizedCustomerEngagement@2x-dfe0bc456a509a179287ec19fa6c1627.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,1382,4136,2073,8392,5735,2429,7303,948,8187,3996,7947,7960,6012,442,2472,3970,9774,2888,179], function() { return __webpack_exec__(36594); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);